<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.552 0-1 .418-1 .933v12.134c0 .515.448.933 1 .933h16c.552 0 1-.418 1-.933V3.933C19 3.418 18.552 3 18 3H2Zm1 12.133V4.867h14v10.266H3Zm2.514-8.99a1 1 0 1 0-1.029 1.715l5 3a1 1 0 0 0 1.03 0l5-3a1 1 0 0 0-1.03-1.715L10 8.834 5.514 6.143Z" />
    </svg>
</template>
